export default {
  computed: {
    $primaryColor() {
      return !this.$isSelf ? 'teal' : 'primary'
      // return !!this.$route.params.guid &&
      //   this.$route.params.guid.toUpperCase() !==
      //     this.$store.state.auth.employeeID.toUpperCase()
      //   ? 'teal'
      //   : 'primary'
    },

    $lang() {
      return this.$root.$i18n.locale
    },

    $tutorialDialog() {
      return this.$store.state.dashboard.tutorialDialog
    }
  },

  methods: {
    $zeroPrefix(value, prefix_count = 2) {
      const prefix = '0'.repeat(prefix_count - 1)
      return (prefix + value).slice(prefix_count * -1)
    },

    $currencyFilter(
      value,
      option = {
        symbol: '',
        thousandsSeparator: ',',
        fractionCount: 2,
        fractionSeparator: '.',
        symbolPosition: '',
        symbolSpacing: '',
        avoidEmptyDecimals: undefined
      }
    ) {
      return this.$options.filters.currency(value, option)
    },

    $concat(items = [], needle = ' ') {
      if (Array.isArray(items)) {
        let res = ''
        for (let index in items) {
          if (
            !Array.isArray(items[index]) &&
            typeof items[index] !== 'object'
          ) {
            res += items[index]
            if (index < items.length - 1) {
              res += needle
            }
          }
        }
        return res.trim()
      }
    },

    $toThaiNumber(num = 0) {
      var array = {
        '1': '๑',
        '2': '๒',
        '3': '๓',
        '4': '๔',
        '5': '๕',
        '6': '๖',
        '7': '๗',
        '8': '๘',
        '9': '๙',
        '0': '๐'
      }
      var str = num.toString()
      for (var val in array) {
        str = str.split(val).join(array[val])
      }
      return str
    }
  }
}
